import { FORA_SOURCE } from '@fora-monorepo/fora-common';
import { PayrollReportHeadViewModel, PayrollReportStatusEnum } from '@fora-monorepo/employer-my-pages-common/types';

export const mockPayrollReportHeadsData: PayrollReportHeadViewModel[] = [
  {
    payrollReportId: 'A33BB92E99751EDE9CCE09965EC72BEE',
    createdDate: '2023-02-25T13:00:00',
    successfullyProcessedDate: '2023-02-25T13:00:00',
    source: FORA_SOURCE,
    status: PayrollReportStatusEnum.PROCESSED,
    hasEmploymentData: true,
    hasEmploymentDeviations: false,
    hasEmploymentInformation: false,
    payMonths: [
      {
        payMonth: '202303',
        hasDeviations: false,
        hasInformation: false,
      },
    ],
    adminReporterFullName: 'Maria LöneAdminsson',
  },
  {
    payrollReportId: 'A33BB92E99751EDE9CCE09965EC72BEA',
    createdDate: '2023-02-21T13:00:00',
    successfullyProcessedDate: '2023-02-21T13:00:00',
    source: FORA_SOURCE,
    status: PayrollReportStatusEnum.PROCESSED,
    hasEmploymentData: false,
    hasEmploymentDeviations: false,
    hasEmploymentInformation: false,
    payMonths: [
      {
        payMonth: '202303',
        hasDeviations: false,
        hasInformation: false,
      },
      {
        payMonth: '202301',
        hasDeviations: false,
        hasInformation: false,
      },
    ],
    adminReporterFullName: 'Maria LöneAdminsson',
  },
  {
    payrollReportId: 'A33BB92E99751EDE9CCE09965EC72BEB',
    createdDate: '2023-01-26T13:00:00',
    successfullyProcessedDate: '2023-01-26T13:00:00',
    source: 'Fortnox',
    status: PayrollReportStatusEnum.PROCESSED,
    hasEmploymentData: true,
    hasEmploymentDeviations: false,
    hasEmploymentInformation: false,
    payMonths: [
      {
        payMonth: '202301',
        hasDeviations: false,
        hasInformation: false,
      },
    ],
    adminReporterFullName: 'Maria LöneAdminsson',
  },
  {
    payrollReportId: 'A33BB92E99751EDE9CCE09965EC72BEC',
    createdDate: '2023-03-18T13:00:00',
    successfullyProcessedDate: '2023-03-18T13:00:00',
    source: FORA_SOURCE,
    status: PayrollReportStatusEnum.PROCESSED,
    hasEmploymentData: false,
    hasEmploymentDeviations: false,
    hasEmploymentInformation: false,
    payMonths: [
      {
        payMonth: '202303',
        hasDeviations: true,
        hasInformation: false,
      },
    ],
    adminReporterFullName: 'Maria LöneAdminsson',
  },
  {
    payrollReportId: 'A33BB92E99751EDE9CCE09965EC72BED',
    createdDate: '2023-06-04T13:00:00',
    successfullyProcessedDate: null,
    source: FORA_SOURCE,
    status: PayrollReportStatusEnum.PROCESSING,
    hasEmploymentData: true,
    hasEmploymentDeviations: true,
    hasEmploymentInformation: false,
    payMonths: [
      {
        payMonth: '202306',
        hasDeviations: false,
        hasInformation: false,
      },
    ],
    adminReporterFullName: 'Maria LöneAdminsson',
  },
  {
    payrollReportId: 'A33BB92E99751EDE9CCE09965EC72BEF',
    createdDate: '2023-02-13T13:00:00',
    successfullyProcessedDate: '2023-02-13T13:00:00',
    source: FORA_SOURCE,
    status: PayrollReportStatusEnum.PROCESSED,
    hasEmploymentData: false,
    hasEmploymentDeviations: false,
    hasEmploymentInformation: false,
    payMonths: [
      {
        payMonth: '202304',
        hasDeviations: false,
        hasInformation: false,
      },
    ],
    adminReporterFullName: 'Maria LöneAdminsson',
  },
  {
    payrollReportId: 'A33BB92E99751EDE9CCE09965EC72BEG',
    createdDate: '2023-02-14T13:00:00',
    successfullyProcessedDate: '2023-02-14T13:00:00',
    source: FORA_SOURCE,
    status: PayrollReportStatusEnum.PROCESSED,
    hasEmploymentData: true,
    hasEmploymentDeviations: false,
    hasEmploymentInformation: true,
    payMonths: [
      {
        payMonth: '202305',
        hasDeviations: true,
        hasInformation: false,
      },
    ],
    adminReporterFullName: 'Maria LöneAdminsson',
  },
];
